<template>
  <div>
    <van-field
      v-model="val"
      :label="label"
      :placeholder="placeholder || label"
      :required="required"
      :rules="[{ required: required, message: '请选择' + label }]"
      readonly
      is-link
      @click="show = true"
    />
    <van-popup v-model="show" position="bottom" round >
      <van-datetime-picker
        v-model="currDate"
        :title="'选择 ' + label"
        type="datetime"
        @confirm="change"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      val: this.value,
      currDate: this.value ? new Date(this.value) : new Date()
    }
  },
  watch: {
    value: function(value) {
      this.val = value
      this.currDate = new Date(value)
    }
  },
  methods: {
    change(value) {
      this.val = this.Utils.df(value, '{y}-{m}-{d} {h}:{i}:{s}')
      this.$emit('change', this.val)
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseDatetime.vue